<template>
  <div
    class="new-order-v4"
    :class="componentClasses"
  >
    <div class="new-order-v4__header">
      <c-btn
        v-if="!isOldOffer"
        disable-style
        :w100="false"
        class="new-order-v4__back-btn"
        @click="clickArrow"
      >
        <div class="new-order-v4__arrow-icon">
          <sprite
            src="sprites_arrow-m-left"
            class="new-order-v4__icon-sprite"
          />
        </div>
      </c-btn>
      <p class="new-order-v4__title">
        <span v-if="title">
          {{ title }}
        </span>
        <span v-else>
          Выбор меню
        </span>
      </p>
    </div>
    <!-- это для баннера на мобильных DEV-15874 -->
    <template v-if="isBannerVisible">
      <img
        :src="require('@/assets/images/newOrder/banner_cmz=1ZV7.png')"
        class="new-order-v4__banner-cmz"
        alt=""
      >
    </template>
    <!-- - это для баннера на мобильных DEV-15874 -->
    <template v-if="isEconomTariffPage">
      <DeliveryDaysSelector
        v-if="isOfferPageMode"
        is-empty-mode
        :menu="selectedMenu"
        :delivery-days="deliveryDaysByMenuType"
        :selected-delivery-date="selectedDeliveryDate"
        :is-welcome-set="isWelcomeSetPage"
        :number-of-days-in-delivery="numberOfDaysInDelivery"
        @select="selectDeliveryDate"
      />
      <ViewsSelector
        :selected-view="selectedView"
        :views="views"
        @selectView="selectView"
      />
      <DishesSelector
        v-if="isDishesSelectorDisplayed"
        :is-light-label-visible="isHaveTariffVersion"
        :is-title-visible="!isHaveTariffVersion"
        :menu-types="menuTypes"
        :default-menu-type="defaultMenuType"
        @select="getMenu"
      />
      <CaloriesSelector
        v-if="isCaloriesSelectorDisplayed"
        :is-title-visible="!isHaveTariffVersion"
        :menu-types="menuTypes"
        :default-menu-type="defaultMenuType"
        @select="getMenu"
      />
      <div
        v-if="!isMenuLoading"
        :key="menuKey"
        class="new-order-v4__menu-wrapper"
      >
        <OrderMenu
          :selected-menu-type="selectedMenuType"
          :menu="selectedMenu"
          :show-pack-calories="isCaloriesSelectorDisplayed"
        />
        <EatingDaysSelector
          v-show="isEatingDaysSelectorVisible"
          :meal-days="selectedMealDays"
          @select="selectEatingDays"
        />
        <Transition name="fade">
          <div
            v-if="isBonusesInfoVisible"
            class="new-order-v4-bonuses"
          >
            <Image
              class="new-order-v4-bonuses__icon"
              src="@/assets/images/bonus-rounded.svg"
            />
            <div class="new-order-v4-bonuses__text">
              Кешбэк выдаётся бонусами за первый заказ на {{ $numberLingFormWithNumberFunc(selectedEatingDays.numberOfMealDays, 'день', 'дня', 'дней') }}
            </div>
          </div>
        </Transition>
        <p
          v-if="isEatingDaysSelectorVisible"
          class="new-order-v4__price"
        >
          <span
            v-if="isOldPriceVisible"
            class="new-order-v4__old-price"
          >{{ $formatMoney(oldPrice) }}</span>
          {{ $formatMoney(price) }} ₽ в день
        </p>
      </div>
    </template>
    <template v-else-if="!isWelcomeSetPage">
      <DeliveryDaysSelector
        v-if="isOfferPageMode"
        is-empty-mode
        :menu="selectedMenu"
        :delivery-days="deliveryDaysByMenuType"
        :selected-delivery-date="selectedDeliveryDate"
        :is-welcome-set="isWelcomeSetPage"
        :number-of-days-in-delivery="numberOfDaysInDelivery"
        @select="selectDeliveryDate"
      />
      <GoalsSelector
        :is-title-visible="!isHaveTariffVersion"
        :custom-text="views"
        @selectGoal="selectGoal"
      />
      <DishesSelector
        v-if="isDishesSelectorDisplayed"
        :is-title-visible="!isHaveTariffVersion"
        :menu-types="menuTypes"
        :default-menu-type="defaultMenuType"
        @select="getMenu"
      />
      <CaloriesSelector
        v-if="isCaloriesSelectorDisplayed"
        :is-title-visible="!isHaveTariffVersion"
        :menu-types="menuTypes"
        :default-menu-type="defaultMenuType"
        @select="getMenu"
      />
      <div
        v-if="!isMenuLoading"
        :key="menuKey"
        class="new-order-v4__menu-wrapper"
      >
        <OrderMenu
          :selected-menu-type="selectedMenuType"
          :menu="selectedMenu"
          :show-pack-calories="isCaloriesSelectorDisplayed"
        />
        <EatingDaysSelector
          v-show="isEatingDaysSelectorVisible"
          :meal-days="selectedMealDays"
          @select="selectEatingDays"
        />
        <Transition name="fade">
          <div
            v-if="isBonusesInfoVisible"
            class="new-order-v4-bonuses"
          >
            <Image
              class="new-order-v4-bonuses__icon"
              src="@/assets/images/bonus-rounded.svg"
            />
            <div class="new-order-v4-bonuses__text">
              Кешбэк выдаётся бонусами за первый заказ на {{ $numberLingFormWithNumberFunc(selectedEatingDays.numberOfMealDays, 'день', 'дня', 'дней') }}
            </div>
          </div>
        </Transition>
        <p
          v-if="isEatingDaysSelectorVisible"
          class="new-order-v4__price"
        >
          <span
            v-if="isOldPriceVisible"
            class="new-order-v4__old-price"
          >{{ $formatMoney(oldPrice) }}</span>
          {{ $formatMoney(price) }} ₽ в день
        </p>
      </div>
    </template>
    <template v-else-if="!isSkeletonVisible && welcomeSetPageBanner">
      <img
        :src="welcomeSetPageBanner"
        alt=""
        class="new-order-v4__welcome-set-banner"
      >
      <WelcomeSetMenu :menu="selectedMenu" />
    </template>
    <PageSkeleton
      v-if="isSkeletonVisible"
      :is-menu-types-loading="isMenuTypesLoading"
      :is-welcome-set="isWelcomeSetPage"
    />
    <template v-if="!isMenuLoading">
      <DeliveryDaysSelector
        v-if="!isOfferPageMode"
        :menu="selectedMenu"
        :delivery-days="deliveryDaysByMenuType"
        :selected-delivery-date="selectedDeliveryDate"
        :is-welcome-set="isWelcomeSetPage"
        :number-of-days-in-delivery="numberOfDaysInDelivery"
        @select="selectDeliveryDate"
      />
      <div class="new-order-v4__btn-wrapper">
        <CoreButton
          w100
          class-name="new-order-v4__btn"
          type="from-var"
          :loading="isOrderLoading"
          @click="onButtonClick"
        >
          {{ orderButtonText }}&nbsp;
          <span
            v-if="isWelcomeSetOldPriceVisible"
            class="new-order-v4__old-btn-price"
          >
            {{ welcomeSetOldPrice }}
          </span>
          <span
            v-if="isOfferPageMode && !isWelcomeSetPage && minMealDaysPrice"
            class="new-order-v4__price-to-right"
            v-html="minMealDaysPrice"
          />
          <span
            v-if="isFullPriceMode && fullPriceText"
            class="new-order-v4__price-to-right"
            v-html="fullPriceText"
          />
          <div
            v-if="isCashBackVisible"
            class="new-order-v4__btn-cashback"
          >
            100% кешбэк
          </div>
          <Image
            v-if="isLabelVisible"
            class="new-order-v4__btn-label"
            src="@/assets/images/offer-images/persent-icon.svg"
          />
        </CoreButton>
        <div
          v-if="isLabelVisible"
          class="new-order-v4__promo-info"
        >
          {{ labelText }}
        </div>
      </div>
      <div
        v-if="isExpressDeliveryVisible && !isWelcomeSetPage"
        class="new-order-v4__delivery-info"
      >
        Доставка за 2 часа доступна не во всех районах
      </div>
      <CoreButton
        v-if="isWelcomeSetPage"
        w100
        class-name="new-order-v4__btn new-order-v4__btn--welcome-set-order"
        type="success"
        @click="openDropDown"
      >
        Заказать через оператора
      </CoreButton>
    </template>
    <WelcomeSetBanner
      v-if="isWelcomeSetBannerVisible"
      :image="welcomeSetData?.checkoutBannerImage"
      :place="welcomeSetBannerRef"
    />
    <CoreDropdown
      :show-content="isDropDownVisible"
      separate-click-out-side-action
      container=".new-order-v4"
      mode="bottom"
      bottom-title="Заказать через оператора"
      :show-btn="false"
      @clickOutSide="hideDropDown"
      @close="hideDropDown"
    >
      <template #content>
        <div class="new-order-v4-dropdown-content">
          <GfInput
            label="Ваш телефон"
            placeholder="Ваш телефон"
            name="operator-order-input"
            type="tel"
            mask="+7 ### ### ####"
            autofocus
            :is-error="isError"
            :error-text="errorText"
            :model-value="phoneNumber"
            @input="onPhoneInput"
          />
          <CoreButton
            w100
            class-name="new-order-v4-dropdown-content__btn"
            :disabled="isButtonDisabled"
            :loading="isWelcomeSetLoading"
            type="from-var"
            @click="createWelcomeSet"
          >
            Заказать
          </CoreButton>
        </div>
      </template>
    </CoreDropdown>
    <transition
      name="fade"
      duration="150"
    >
      <SelectOffer
        v-if="isSelectOfferModalOpened"
        :number-of-meals="numberOfMeals"
        :meal-days="selectedMealDays"
        :is-econom-tariff-page="isEconomTariffPage"
        :is-calories="isCaloriesSelectorDisplayed"
        :is-loading="isOrderLoading"
        :selected-menu-type="selectedMenuType"
        :first-delivery-discount-enabled="isFirstOrderDiscountEnabled"
        @select="selectEatingDays"
        @buttonClick="onOfferButtonClick"
        @close="closeSelectOfferModal"
      />
    </transition>
  </div>
</template>

<script>
import GoalsSelector from '@/components/newOrderV4/GoalsSelector'
import ViewsSelector from '@/components/newOrderV4/ViewsSelector'
import SelectOffer from '@/components/newOrderV4/SelectOffer'

import DishesSelector from '@/components/newOrderV4/DishesSelector'
import CaloriesSelector from '@/components/newOrderV4/CaloriesSelector'
import OrderMenu from '@/components/newOrderV4/OrderMenu'
import WelcomeSetMenu from '@/components/newOrderV4/WelcomeSetMenu'
import EatingDaysSelector from '@/components/newOrderV4/EatingDaysSelector'
import DeliveryDaysSelector from '@/components/newOrderV4/DeliveryDaysSelector'
import PageSkeleton from '@/components/newOrderV4/PageSkeleton'
import WelcomeSetBanner from '@/components/newOrderV4/WelcomeSetBanner'
import CoreButton from '@/components/core/ui/CoreButton'
import GfInput from '@/components/core/ui/InputV2'
import CoreDropdown from '@/components/core/ui/CoreDropdownV2/CoreDropdown'

import { openModalScroll, closeModalScroll } from '@/services/modal'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import { mapVCP } from '@/services/mapVCP'
import apiMenu from '@/api/menu'
import apiOrder from '@/api/orders'
import { getRawPrice } from '@/services/cosmeticDiscount'

import { getFirstDaysDiscount } from '@/services/helpers'

import {
  CosmeticDiscount,
  CAHBACK_VISIBLE_THRESHOLD,
  WELCOME_SET,
  WelcomeSetInfo,
  EconomSetInfo,
  PersonalSetInfo,
  CALORIES,
  MEALS,
  HIGH,
  MEDIUM,
  ECONOM_START_NAMES,
  SUBSCRIPTION_PRICE_DIVIDER,
  CMZ_OLD_OFFERS,
  BANNER_ON_CMZ,
} from '@/config/constants'

const VIEWS_CODES = [
  {
    code: CALORIES,
    goalCode: HIGH,
    title: 'По калориям',
  },
  {
    code: MEALS,
    goalCode: MEDIUM,
    title: 'По блюдам',
  },
]

const MENU_DAYS_TO_SHOW = 12
const WELCOME_SET_MEAL_DAYS = 2
const CUSTOM_WELCOME_SET_PROMO_CODE = 'WELCOME-TSET'

const WelcomeSetInputErrors = {
  EMPTY_FIELD: 'Поле обязательно для заполнения',
  INVALID_PHONE: 'Указан некорректный номер телефона',
  UNKNOWN_ERROR: 'Произошла ошибка, попробуйте позже',
}

const WelcomeSetBannerRefs = {
  COOK: 'banner-cook',
  FIT: 'banner-fit',
}

export default {
  name: 'IndexV4',

  components: {
    CaloriesSelector,
    GoalsSelector,
    ViewsSelector,
    SelectOffer,
    DishesSelector,
    OrderMenu,
    EatingDaysSelector,
    DeliveryDaysSelector,
    PageSkeleton,
    CoreButton,
    WelcomeSetBanner,
    WelcomeSetMenu,
    CoreDropdown,
    GfInput,
  },
  data () {
    return {
      selectedGoal: null,
      selectedView: VIEWS_CODES[0],
      selectedMenu: {},
      selectedMenuType: null,
      selectedEatingDays: null,
      selectedDeliveryDate: null,
      loadedMenus: {},
      isFirstMenuLoading: true,
      isMenuTypesLoading: true,
      isMenuLoading: true,
      isOrderLoading: false,
      menuKey: 0,
      isDropDownVisible: false,
      requestPhoneNumber: '',
      isError: false,
      errorText: '',
      isButtonDisabled: false,
      isWelcomeSetLoading: false,
      isSelectOfferModalOpened: false,
      menuRequestQueue: [],
    }
  },

  computed: {
    ...mapGetters('city', {
      activeCity: 'getActive',
    }),
    ...mapGetters('marketing', [
      'isCosmeticDiscountVisible',
      'isWelcomeSetVisible',
      'isExpressDeliveryVisible',
      'isCustomWelcomeSet',
      'specificQueryParams',
      'isFizikl',
    ]),
    ...mapGetters('customizationInfo', ['deliveryDays']),
    ...mapGetters('client', ['isLoggedIn', 'profile']),
    ...mapGetters('goals', ['goals']),
    ...mapGetters('vcp', ['vcpConfigLoaded']),

    ...mapVCP({
      welcomeSetData: 'NewLandingVisual/WelcomeSet',
    }),
    isOldOffer () {
      return this.specificQueryParams?.cmz === CMZ_OLD_OFFERS
    },

    isOfferPageMode () {
      if (this.isOldOffer) {
        return false
      }
      // TODO: DEV-15367 добавить АБ
      return true
    },
    isFullPriceMode () {
      if (this.isWelcomeSetPage) {
        return false
      }
      if (this.isOldOffer) {
        if (this.selectedEatingDays.subscriptionDays) {
          return false
        }
        return true
      }
      return false
    },

    isCashBackVisible () {
      if (this.selectedMenuType === 'breakfasts_2x') {
        return false
      }
      return this.isOldOffer && !this.isEconomTariffPage && !this.isWelcomeSetPage
    },

    isLabelVisible () {
      return (this.isOfferPageMode || this.isPersonalSetPage) && !this.isWelcomeSetPage && !this.isEconomTariffPage
    },

    labelText () {
      return getFirstDaysDiscount(this.firstOrderDiscount?.discountValue)
    },

    welcomeSetPageBanner () {
      return this.welcomeSetData?.homepageBannerImage
    },

    isHaveTariffVersion () {
      return this.$route.params?.tariff || false
    },

    views () {
      if (this.isFizikl) {
        return [VIEWS_CODES[1]]
      }
      if (this.isHaveTariffVersion) {
        return VIEWS_CODES
      }
      return null
    },

    componentClasses () {
      return {
        'new-order-v4--save': this.isEconomTariffPage,
        'new-order-v4--welcome-set': this.isWelcomeSetPage,
      }
    },

    title () {
      if (this.$route.params.tariff === EconomSetInfo.TYPE) {
        return EconomSetInfo.TITLE
      }
      if (this.$route.params.tariff === PersonalSetInfo.TYPE) {
        return PersonalSetInfo.TITLE
      }
      if (this.$route.params.tariff === WELCOME_SET || this.$route.params.goal === WELCOME_SET) {
        return WelcomeSetInfo.TITLE
      }
      return null
    },

    phoneNumber () {
      const phone = this.profile.phone
      if (phone) {
        return phone.substring(1)
      }
      return ''
    },

    isBonusesInfoVisible () {
      if (!this.isEatingDaysSelectorVisible) {
        return false
      }
      const cashbackInfo = this.selectedEatingDays?.promoInfo?.benefitValues.find(
        value => value.benefitType === 'cashback_percent_base',
      )
      return cashbackInfo && (cashbackInfo?.value * 100 / this.selectedEatingDays.fullPrice) > CAHBACK_VISIBLE_THRESHOLD
    },
    selectedGoalCode () {
      return this.selectedGoal?.code
    },
    selectedViewCode () {
      return this.selectedView?.code
    },

    numberOfDaysInDelivery () {
      if (this.selectedMenu) {
        return this.selectedMenu?.config?.numberOfDaysInDelivery
      }
      return 2
    },

    isDishesSelectorDisplayed () {
      if (this.isEconomTariffPage) {
        return this.selectedViewCode === MEALS
      }
      return this.selectedGoalCode === MEDIUM
    },

    isCaloriesSelectorDisplayed () {
      if (this.isEconomTariffPage) {
        return this.selectedViewCode === CALORIES
      }
      return this.selectedGoalCode === HIGH
    },

    welcomeSetOldPrice () {
      return this.welcomeSetData?.homepagePrice
    },

    isWelcomeSetOldPriceVisible () {
      return this.isWelcomeSetPage && this.welcomeSetOldPrice
    },

    isWelcomeSetPage () {
      return this.$route.params.tariff === WELCOME_SET || this.$route.params.goal === WELCOME_SET
    },

    isEconomTariffPage () {
      return this.$route.params.tariff === EconomSetInfo.TYPE
    },

    isPersonalSetPage () {
      return this.$route.params.tariff === PersonalSetInfo.TYPE
    },

    welcomeSetBannerRef () {
      if (this.isDishesSelectorDisplayed) {
        return WelcomeSetBannerRefs.COOK
      }
      if (this.isCaloriesSelectorDisplayed) {
        return WelcomeSetBannerRefs.FIT
      }
      return ''
    },

    economMenuTypes () {
      const economMenuTypes = []
      this.goals.forEach(goal => {
        goal.menuTypes.forEach(menuType => {
          // ищем эконом тарифы
          if (menuType.type.startsWith(ECONOM_START_NAMES)) {
            const economMenuTypeIndex = economMenuTypes.findIndex(economMenuType => economMenuType.type === menuType.type)
            if (economMenuTypeIndex < 0) {
              economMenuTypes.push(menuType)
            }
          }
        })
      })
      economMenuTypes.sort((a, b) => a.kcal - b.kcal)
      return economMenuTypes
    },
    menuTypes () {
      if (this.isEconomTariffPage) {
        return this.economMenuTypes || []
      }
      const menuTypes = []
      this.selectedGoal.menuTypes.forEach(menuType => {
        // исключаем эконом тарифы
        if (!menuType.type.startsWith(ECONOM_START_NAMES)) {
          menuTypes.push(menuType)
        }
      })
      return menuTypes || []
    },
    selectedMenuTypeInfo () {
      return this.menuTypes.find((menuType) => menuType.type === this.selectedMenuType) || null
    },
    numberOfMeals () {
      return (this.selectedMenuTypeInfo && this.selectedMenuTypeInfo.pricePlan.realNumberOfMeals) || 0
    },
    defaultMenuType () {
      if (this.isEconomTariffPage) {
        return this.menuTypes[0].type
      }
      return this.selectedGoal?.defaultMenuType || ''
    },

    selectedMealDays () {
      const menuType = this.menuTypes.find((menuType) => menuType.type === this.selectedMenuType)
      return menuType?.pricePlan.mealDays || []
    },
    firstOrderDiscount () {
      let firstOrderDiscount = null
      this.selectedMealDays.forEach(mealDay => {
        firstOrderDiscount = mealDay.promoInfo.benefitValues.find((benefit) => {
          return benefit.type === 'firstorderpercent'
        })
      })
      return firstOrderDiscount
    },
    isFirstOrderDiscountEnabled () {
      return !!this.firstOrderDiscount
    },
    minMealDaysPrice () {
      if (this.isWelcomeSetPage) {
        return null
      }
      let min = Number.MAX_VALUE
      this.selectedMealDays.forEach((mealDay) => {
        const permanentSubscriptionPrice = mealDay.permanentSubscription?.price || min
        const dayPrice = Math.min(permanentSubscriptionPrice, mealDay.promoInfo.dayPrice)
        if (min > dayPrice) {
          min = dayPrice
        }
      })
      if (min === Number.MAX_VALUE) {
        return null
      }
      return `от ${this.$formatMoney(min)}&nbsp;₽ в день`
    },

    promoPrice () {
      return this.selectedEatingDays?.promoInfo.price
    },
    // Полная цена без скидок
    fullPrice () {
      return this.selectedEatingDays?.promoInfo.fullPrice || this.selectedEatingDays?.fullPrice
    },
    // Цена за все с учетом скидки
    realFullPrice () {
      let price = this.promoPrice || this.selectedEatingDays?.price
      if (!this.selectedEatingDays?.subscriptionDays) {
        price = price * this.selectedEatingDays.numberOfMealDays
      }
      return price
    },

    price () {
      let price = this.promoPrice || this.selectedEatingDays?.price
      if (this.selectedEatingDays?.subscriptionDays) {
        price = Math.round(price / SUBSCRIPTION_PRICE_DIVIDER)
      }
      return price
    },

    oldPrice () {
      if (this.isCosmeticDiscountVisible) {
        const selectedDays = this.selectedEatingDays?.subscriptionDays || this.selectedEatingDays?.numberOfMealDays
        return getRawPrice(this.price, CosmeticDiscount[selectedDays])
      }

      let oldPrice = this.promoPrice ? this.selectedEatingDays?.price : null
      if (this.selectedEatingDays?.subscriptionDays) {
        oldPrice = oldPrice ? Math.round(oldPrice / SUBSCRIPTION_PRICE_DIVIDER) : null
      }
      return oldPrice
    },

    isOldPriceVisible () {
      return this.oldPrice > this.price
    },

    deliveryDaysByMenuType () {
      const deliveryDaysByMenuType = this.deliveryDays?.find((item) => item.menuType === this.selectedMenuType)?.data || []
      const deliveryDays = {}

      deliveryDaysByMenuType.forEach((dayTimeData) => {
        dayTimeData.dates.forEach((date) => {
          if (!deliveryDays[date]) {
            deliveryDays[date] = {
              [dayTimeData.dayTime]: dayTimeData.times,
            }
          } else {
            deliveryDays[date][dayTimeData.dayTime] = dayTimeData.times
          }
        })
      })

      return deliveryDays
    },

    pricePlanId () {
      return this.menuTypes?.find((menuType) => menuType.type === this.selectedMenuType)?.pricePlan.id
    },

    orderRequestObject () {
      const subscriptionIdH = this.selectedEatingDays?.subscriptionId_H
      const mealDays = this.selectedEatingDays?.numberOfMealDays
      const promoCode = this.selectedEatingDays?.promoInfo?.promocode

      const payload = {
        client: {
          cityId: this.cityId,
        },
        deliveriesStartDate: this.selectedDeliveryDate?.date,
        deliveriesStartDateType: this.selectedDeliveryDate?.type,
        order: {
          price_plan_id: this.pricePlanId,
          mealDays: mealDays,
        },
      }

      if (this.selectedDeliveryDate) {
        payload.deliveriesStartDateIntervals = {
          timeFrom: this.selectedDeliveryDate.timeFrom,
          timeTo: this.selectedDeliveryDate.timeTo,
        }
      }

      if (subscriptionIdH) {
        payload.subscriptionId_H = subscriptionIdH
      }

      if (promoCode) {
        payload.promocode = promoCode
      }

      if (this.isWelcomeSetPage) {
        payload.promoMenuType = WELCOME_SET
        payload.order.mealDays = WELCOME_SET_MEAL_DAYS
        payload.promocode = this.isCustomWelcomeSet ? CUSTOM_WELCOME_SET_PROMO_CODE : WELCOME_SET.toUpperCase()
      }

      return payload
    },

    isSkeletonVisible () {
      return this.isMenuTypesLoading || this.isMenuLoading
    },

    cityId () {
      return this.activeCity.id || 1
    },

    isWelcomeSetActive () {
      return this.welcomeSetData?.active
    },

    isWelcomeSetBannerVisible () {
      return this.isWelcomeSetVisible && !this.isMenuLoading && !this.isWelcomeSetPage && this.welcomeSetData?.checkoutBannerImage && this.isWelcomeSetActive
    },

    welcomeSetPrice () {
      return this.welcomeSetData?.homepagePriceWithDiscount
    },

    isEatingDaysSelectorVisible () {
      return !this.isOfferPageMode && this.selectedMealDays && this.selectedMealDays.length > 1
    },

    orderButtonText () {
      if (this.isWelcomeSetPage) {
        return `Заказать за ${this.welcomeSetPrice}`
      }
      if (this.isOfferPageMode) {
        return 'Оформить'
      }
      // TODO: https://growfood.atlassian.net/browse/DEV-15513 подумать над улучщением
      if (this.isOldOffer) {
        return 'Оформить'
      }
      if (this.isEconomTariffPage) {
        return `Заказать за ${this.fullPrice} ₽`
      }
      return 'Заказать'
    },
    fullPriceText () {
      const {
        numberOfMealDays,
        subscriptionDays,
      } = this.selectedEatingDays
      let daysCount = numberOfMealDays
      if (subscriptionDays) {
        daysCount = subscriptionDays
      }
      return `${daysCount} дн. за ${this.realFullPrice} ₽`
    },
    // это для баннера на мобильных DEV-15874
    isBannerVisible () {
      return BANNER_ON_CMZ.includes(this.specificQueryParams?.cmz)
    },
  },

  mounted () {
    this.selectedView = this.isFizikl ? VIEWS_CODES[1] : VIEWS_CODES[0]
  },

  watch: {
    cityId (newVal) {
      if (newVal) {
        this.loadedMenus = {}
      }
    },

    vcpConfigLoaded: {
      handler (newVal) {
        if (!newVal) {
          return
        }

        if (this.isWelcomeSetPage) {
          if (!this.isWelcomeSetActive) {
            this.$router.push('/')
          } else {
            this.getMenu('daily', true, WELCOME_SET_MEAL_DAYS)
          }
        }

        window.scrollTo(0, 0)
        this.sendGTMMarkupEvent({
          block: 'LandingNewOrder',
          element: 'Block',
          action: 'View',
          details: '',
        })
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions('analytics', ['singleEvent', 'firebasePerformanceCustomTraceStart']),
    ...mapActions('order', ['createOrder', 'setPaymentTypes']),
    ...mapActions('goals', ['getMenuGoals']),
    ...mapMutations('modals', ['openModal']),

    onPhoneInput (value) {
      if (value !== this.requestPhoneNumber) {
        this.isError = false
        this.errorText = ''
        this.isButtonDisabled = false
      }
      this.requestPhoneNumber = value
    },

    async createWelcomeSet () {
      if (!this.requestPhoneNumber.length) {
        this.isError = true
        this.errorText = WelcomeSetInputErrors.EMPTY_FIELD
        this.isButtonDisabled = true
        return
      }

      if (this.requestPhoneNumber.length < 15 || this.requestPhoneNumber[3] !== '9') {
        this.isError = true
        this.errorText = WelcomeSetInputErrors.INVALID_PHONE
        this.isButtonDisabled = true
        return
      }

      this.isWelcomeSetLoading = true
      try {
        await apiOrder.createWelcomeSetOrder({
          client: {
            phone: this.requestPhoneNumber,
          },
        })
        this.$router.push({
          name: 'WelcomeSetSuccessPage',
        })
      } catch (error) {
        console.error(error)
        this.isError = true
        this.errorText = error.response?.data?.messages?.[0] || WelcomeSetInputErrors.UNKNOWN_ERROR
        this.isButtonDisabled = true
      } finally {
        this.isWelcomeSetLoading = false
        this.sendGTMMarkupEvent({
          block: 'new_order',
          element: 'order_with_operator',
          action: 'complete',
        })
      }
    },

    clickArrow () {
      this.$router.go(-1)
    },

    selectGoal (goal) {
      this.selectedGoal = goal
    },
    selectView (view) {
      const goal = this.goals?.find((goal) => goal.code === 'medium')
      if (goal) {
        this.selectGoal(goal)
      }
      this.selectedView = view
    },

    updateSelectedDeliveryDate () {
      if (!this.selectedDeliveryDate) {
        return
      }

      const dateInDeliveryDays = this.deliveryDaysByMenuType[this.selectedDeliveryDate.date]
      if (!dateInDeliveryDays || !dateInDeliveryDays[this.selectedDeliveryDate.type]) {
        this.selectedDeliveryDate = null
      }
    },

    async requestMenu (payload, menuType) {
      try {
        const response = await apiMenu.postCustomizationInfoMenu(payload)
        const menu = response.data.data
        this.loadedMenus[menuType] = menu
        this.selectedMenu = menu
        this.selectedMenuType = menuType
      } catch (error) {
        console.error(error)
      } finally {
        if (this.isWelcomeSetPage || this.isEconomTariffPage) {
          const goal = this.goals?.find((goal) => goal.code === 'medium')
          if (goal) {
            this.selectGoal(goal)
          }
        }
        this.updateSelectedDeliveryDate()
        this.menuKey++
      }
    },

    async getMenu (menuType, withoutCache = false, menuDays = MENU_DAYS_TO_SHOW) {
      this.menuRequestQueue.push({ menuType, withoutCache, menuDays })
      this.isMenuTypesLoading = false

      if (this.isMenuLoading && !this.isFirstMenuLoading) {
        return
      }

      this.isFirstMenuLoading = false

      while (this.menuRequestQueue.length) {
        const { menuType, withoutCache, menuDays } = this.menuRequestQueue.shift()

        if (this.loadedMenus[menuType] && !withoutCache) {
          this.selectedMenu = this.loadedMenus[menuType]
          this.selectedMenuType = menuType
          this.updateSelectedDeliveryDate()
          this.menuKey++
          continue
        }

        this.isMenuLoading = true
        const payload = {
          cityId: this.cityId,
          menuType,
          menuDays,
        }

        if (this.selectedDeliveryDate) {
          payload.firstDeliveryDate = this.selectedDeliveryDate.date
          payload.dayTime = this.selectedDeliveryDate.type
        }

        await this.requestMenu(payload, menuType)
      }

      this.isMenuLoading = false
    },

    selectEatingDays (selectedEatingDays) {
      this.selectedEatingDays = selectedEatingDays
      this.sendGTMMarkupEvent({
        block: 'new_order',
        element: 'offers_page_offer',
        action: 'select',
      })
    },

    selectDeliveryDate (selectedDeliveryDate) {
      this.selectedDeliveryDate = selectedDeliveryDate
      this.getMenu(
        this.selectedMenuType,
        true,
        this.isWelcomeSetPage ? WELCOME_SET_MEAL_DAYS : MENU_DAYS_TO_SHOW,
      )
    },

    openSelectOfferModal () {
      this.sendGTMMarkupEvent({
        block: 'LandingNewOrder',
        element: 'ShowOffersButton',
        action: 'Click',
      })
      this.sendGTMMarkupEvent({
        block: 'new_order',
        element: 'offers_page',
        action: 'open',
      })
      this.singleEvent('show_offer_page')
      openModalScroll({ time: 150 })
      this.isSelectOfferModalOpened = true
    },
    closeSelectOfferModal () {
      this.sendGTMMarkupEvent({
        block: 'LandingNewOrder',
        element: 'CloseOffersButton',
        action: 'Click',
      })
      this.sendGTMMarkupEvent({
        block: 'new_order',
        element: 'offers_page',
        action: 'back',
      })
      this.singleEvent('close_offer_page')
      closeModalScroll({ time: 150 })
      this.isSelectOfferModalOpened = false
    },

    async beforeCreateOrder (isPermanentSubscription) {
      this.sendGTMMarkupEvent({
        block: 'LandingNewOrder',
        element: 'CreateOrderButton',
        action: 'Click',
      })

      this.singleEvent('mob_order_place')
      const payload = this.orderRequestObject
      if (isPermanentSubscription && this.selectedEatingDays.numberOfMealDays === 6 && !this.selectedEatingDays.subscriptionId_H) {
        payload.permanentSubscription = true
      }

      if (this.isLoggedIn) {
        await this.afterLogIn({ payload })
        this.$gtm.trackEvent({
          event: 'go_to_step',
          step_number: 2,
          step_option: '',
          form_placement: 'basket',
        })
        return
      }

      this.openModal({
        name: 'EnterPhone',
        params: {
          openCheckoutForm: true,
          menuDays: payload.order.mealDays,
          pricePlanId: this.pricePlanId,
          afterLogIn: async (afterCreateOrder) => {
            await this.afterLogIn({ afterCreateOrder, payload })
          },
          price: this.price,
        },
      })
    },

    onButtonClick () {
      if (this.isOfferPageMode && !this.isWelcomeSetPage) {
        // TODO: DEV-15368 страница "Выберите период"
        this.openSelectOfferModal()
        return
      }
      this.beforeCreateOrder()
    },

    onOfferButtonClick (isPermanentSubscription) {
      this.sendGTMMarkupEvent({
        block: 'new_order',
        element: 'offers_page_pay_btn',
        action: 'click',
      })
      this.beforeCreateOrder(isPermanentSubscription)
    },

    handleError (error) {
      const {
        data: {
          message = '',
          messages,
        } = {},
      } = error || {}
      if (message) {
        this.toast({ group: 'error', title: `${message}` })
        return
      }
      if (messages) {
        messages.forEach((message) => {
          this.toast({ group: 'error', title: message })
        })
      }
    },

    getPromoCode () {
      const selectedGoal = this.goals?.find((goal) => goal.code === this.selectedGoal.code)
      const menuType = selectedGoal?.menuTypes.find((menuType) => menuType.pricePlan.id === this.selectedEatingDays.pricePlanId)
      const mealDay = menuType?.pricePlan.mealDays.find((mealDay) => {
        return mealDay.numberOfMealDays === this.selectedEatingDays.numberOfMealDays && mealDay.subscriptionId_H === this.selectedEatingDays.subscriptionId_H
      })
      return mealDay?.promoInfo.promocode
    },

    async afterLogIn ({ afterCreateOrder = () => {}, payload = null }) {
      this.firebasePerformanceCustomTraceStart('createOrder' + payload.order.mealDays)
      try {
        this.isOrderLoading = true
        await this.getMenuGoals()
        const promoCode = this.getPromoCode()
        if (payload && promoCode) {
          payload.promocode = promoCode
        } else if (promoCode) {
          payload = { promocode: promoCode }
        }
        await this.onCreateOrder({ afterCreateOrder, payload })
      } catch (error) {
        this.handleError(error)
        this.isOrderLoading = false
      }
    },

    async onCreateOrder ({ afterCreateOrder = () => {}, payload = null }) {
      this.sendGTMMarkupEvent({
        block: 'LandingNewOrder',
        element: 'CreateOrder',
        action: 'Click',
        details: this.selectedMenuType,
      })
      try {
        this.isOrderLoading = true
        const response = await this.createOrder(payload || {})
        const { order = {}, success, messages, errorCode, paymentTypes } = response
        this.$gtm.trackEvent({
          event: 'order_authorized',
          product_price: order.menuPrice,
          product_menu_type: order.menuType,
          product_meal_days: order.numberOfDays,
          product_city_id: order.cityId,
          order_id: order.id_H,
          order_price: order.debPrice,
          anti_double_handled: response.anti_double_handled,
        })

        if (paymentTypes) {
          this.setPaymentTypes(paymentTypes)
        }

        if (success) {
          const { id_H: idH = '' } = order

          await this.$router.push({
            name: 'LandingNewOrder',
            params: {
              orderId: idH,
              orderJson: order ? JSON.stringify(order) : null,
            },
          })

          afterCreateOrder()
          return
        }

        if (!errorCode || !messages) {
          return
        }

        messages.forEach((message) => {
          this.toast({ group: 'error', title: message })
        })
      } catch (error) {
        this.handleError(error)
      } finally {
        afterCreateOrder()
        this.closeSelectOfferModal()
        this.isOrderLoading = false
      }
    },

    openDropDown () {
      this.isDropDownVisible = true
      this.sendGTMMarkupEvent({
        block: 'new_order',
        element: 'order_with_operator',
        action: 'click',
      })
    },

    hideDropDown () {
      this.isDropDownVisible = false
    },
  },
}
</script>

<style lang="scss">
.new-order-v4 {
  font-size: 24px;
  padding: 16px;
  &__price-to-right {
    margin-left: auto;
  }
  &__btn-cashback {
    position: absolute;
    right: -.04rem;
    top: -.04rem;
    padding: .04rem .06rem;
    font-size: .08rem;
    font-weight: 500;
    line-height: .08rem;
    color: #FFFFFF;
    border-radius: .08rem;
    text-transform: uppercase;
    white-space: nowrap;
    background: linear-gradient(134deg, #638FFF -1.69%, #8962F8 97.05%);
  }
  &__btn-label {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 20px;
    height: 20px;
  }
  &__promo-info {
    margin-top: 10px;
    height: 16px;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #FA414B;
  }

  &__header {
    display: flex;
    align-items: center;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-right: auto;
    margin-left: auto;
  }

  &__back-btn {
    padding: 0.04rem;
    border: unset;
    background: unset;
    cursor: pointer;
    position: absolute;
  }

  &__arrow-icon {
    width: 24px;
    height: 24px;
  }

  &__icon-sprite.c-icon {
    fill: map-get($colors, 'black_0');
    stroke: transparent;
    width: 100%;
    height: 100%;
  }

  &__price {
    margin-top: 16px;
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    padding: 0 16px;
  }

  &__old-price {
    text-decoration-line: line-through;
    color: map-get($colors, 'grey_30');
    font-weight: normal;
  }

  &__btn {
    position: relative;
    max-height: 48px;
    min-height: 48px;
    padding: 14px 16px;
    border-radius: 16px;
    font-size: 14px;
    line-height: 20px;

    &--welcome-set-order {
      margin-top: 12px;
    }
  }
  &__btn-wrapper {
    position: sticky;
    bottom: 0;
    padding: 8px 16px 32px;
    margin: 0 -16px;
    z-index: 100;
    background: map-get($colors, 'white');
  }

  &__welcome-set-banner {
    margin: 24px 0 0;
  }

  &__old-btn-price {
    opacity: 0.5;
    text-decoration: line-through;
  }

  &__menu-wrapper {
    margin: 0 -16px;
    overflow-x: hidden;
  }

  &__delivery-info {
    display: flex;
    justify-content: center;
    color: map-get($colors, 'grey_60');
    font-size: 12px;
    line-height: 16px;
    margin-top: 18px;
    padding-bottom: 18px;
    position: absolute;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
  }

  &--welcome-set {
    padding-bottom: 48px;
    --bg-color: #55B1F4;
  }

  &--save {
    --color: #000000;
    --bg-color: #FEBE03;
    --bg-color--secondary: #D92400;
  }
  &__banner-cmz {
    margin-top: 16px;
  }
}

.new-order-v4-dropdown-content {
  padding: 32px 24px 24px;

  &__btn {
    padding: 12px;
    max-height: 44px;
    min-height: 44px;
    border-radius: 14px;
    font-size: 14px;
    line-height: 20px;
    margin-top: 32px;
  }
}

.new-order-v4-bonuses {
  margin: 12px 16px 0;
  padding: 10px 16px;
  border-radius: 14px;
  background: map-get($colors, 'grey_4');
  display: flex;
  align-items: center;

  &__text {
    color: map-get($colors, 'grey_60');
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.1px;
  }

  &__icon {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }
}

</style>
